/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetGameMinecraftHistoryidRequest = {
  name?: string | undefined;
  uuid?: string | undefined;
};

export const GetGameMinecraftHistoryidRequest$zodSchema: z.ZodType<
  GetGameMinecraftHistoryidRequest
> = z.object({
  name: z.string().describe(
    "玩家的 Minecraft 用户名。使用此参数查询时，会返回所有匹配用户的列表（包括当前用户名或曾用名匹配的玩家）。",
  ).optional(),
  uuid: z.string().describe(
    "玩家的 Minecraft UUID，支持带连字符或不带连字符格式。",
  ).optional(),
});

export type GetGameMinecraftHistoryidBadGatewayDetails = {};

export const GetGameMinecraftHistoryidBadGatewayDetails$zodSchema: z.ZodType<
  GetGameMinecraftHistoryidBadGatewayDetails
> = z.object({});

/**
 * 服务暂时不可用，请稍后重试。
 */
export type GetGameMinecraftHistoryidBadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftHistoryidBadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftHistoryidBadGatewayResponseBody$zodSchema:
  z.ZodType<GetGameMinecraftHistoryidBadGatewayResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetGameMinecraftHistoryidBadGatewayDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("服务暂时不可用，请稍后重试。");

export type GetGameMinecraftHistoryidNotFoundDetails = {};

export const GetGameMinecraftHistoryidNotFoundDetails$zodSchema: z.ZodType<
  GetGameMinecraftHistoryidNotFoundDetails
> = z.object({});

/**
 * 用户未找到。我们根据你提供的 UUID 未能找到对应的 Minecraft 玩家。请确认 UUID 是否正确。
 */
export type GetGameMinecraftHistoryidNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftHistoryidNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftHistoryidNotFoundResponseBody$zodSchema: z.ZodType<
  GetGameMinecraftHistoryidNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetGameMinecraftHistoryidNotFoundDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe(
  "用户未找到。我们根据你提供的 UUID 未能找到对应的 Minecraft 玩家。请确认 UUID 是否正确。",
);

export type GetGameMinecraftHistoryidBadRequestDetails = {};

export const GetGameMinecraftHistoryidBadRequestDetails$zodSchema: z.ZodType<
  GetGameMinecraftHistoryidBadRequestDetails
> = z.object({});

/**
 * 请求失败。请检查你是否提供了 `name` 或 `uuid` 参数中的至少一个。
 */
export type GetGameMinecraftHistoryidBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftHistoryidBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftHistoryidBadRequestResponseBody$zodSchema:
  z.ZodType<GetGameMinecraftHistoryidBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetGameMinecraftHistoryidBadRequestDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe(
    "请求失败。请检查你是否提供了 `name` 或 `uuid` 参数中的至少一个。",
  );

export type ResultHistory = {
  name?: string | undefined;
  changedToAt?: string | undefined;
};

export const ResultHistory$zodSchema: z.ZodType<ResultHistory> = z.object({
  changedToAt: z.string().optional(),
  name: z.string().optional(),
});

export type GetGameMinecraftHistoryidResult = {
  id?: string | undefined;
  uuid?: string | undefined;
  name_num?: number | undefined;
  history?: Array<ResultHistory> | undefined;
};

export const GetGameMinecraftHistoryidResult$zodSchema: z.ZodType<
  GetGameMinecraftHistoryidResult
> = z.object({
  history: z.array(z.lazy(() => ResultHistory$zodSchema)).optional(),
  id: z.string().optional(),
  name_num: z.int().optional(),
  uuid: z.string().optional(),
});

export type History = {
  changedToAt?: string | undefined;
  name?: string | undefined;
};

export const History$zodSchema: z.ZodType<History> = z.object({
  changedToAt: z.string().optional(),
  name: z.string().optional(),
});

/**
 * 响应结构根据查询参数不同而变化
 */
export type GetGameMinecraftHistoryidResponseBody = {
  query?: string | undefined;
  count?: number | undefined;
  results?: Array<GetGameMinecraftHistoryidResult> | undefined;
  id?: string | undefined;
  uuid?: string | undefined;
  name_num?: number | undefined;
  history?: Array<History> | undefined;
};

export const GetGameMinecraftHistoryidResponseBody$zodSchema: z.ZodType<
  GetGameMinecraftHistoryidResponseBody
> = z.object({
  count: z.int().optional(),
  history: z.array(z.lazy(() => History$zodSchema)).optional(),
  id: z.string().optional(),
  name_num: z.int().optional(),
  query: z.string().optional(),
  results: z.array(z.lazy(() => GetGameMinecraftHistoryidResult$zodSchema))
    .optional(),
  uuid: z.string().optional(),
}).describe("响应结构根据查询参数不同而变化");

export type GetGameMinecraftHistoryidResponse =
  | GetGameMinecraftHistoryidResponseBody
  | GetGameMinecraftHistoryidBadRequestResponseBody
  | GetGameMinecraftHistoryidNotFoundResponseBody
  | GetGameMinecraftHistoryidBadGatewayResponseBody;

export const GetGameMinecraftHistoryidResponse$zodSchema: z.ZodType<
  GetGameMinecraftHistoryidResponse
> = z.union([
  z.lazy(() => GetGameMinecraftHistoryidResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftHistoryidBadRequestResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftHistoryidNotFoundResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftHistoryidBadGatewayResponseBody$zodSchema),
]);
